import React from 'react';
import { Layout } from '@storable/canaveral-components';
import BuilderBlogActiveToggle from '../containers/BuilderBlogActiveToggle';

const { Header } = Layout;

const propTypes = {};

const defaultProps = {};

const BuilderLayoutControls = () => (
  <Header.Group pull="right" bordered>
    <BuilderBlogActiveToggle />
  </Header.Group>
);

BuilderLayoutControls.propTypes = propTypes;
BuilderLayoutControls.defaultProps = defaultProps;

export default BuilderLayoutControls;
